const getTimeStringDate = (dateTime: Date): string => {
  const now = new Date();
  const elapsedTime = Math.floor((now.getTime() - dateTime.getTime()) / 1000); // in seconds

  if (elapsedTime < 60) {
    return 'Just now';
  } else if (elapsedTime < 3600) {
    const minutes = Math.floor(elapsedTime / 60);
    return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
  } else if (elapsedTime < 86400) {
    const hours = Math.floor(elapsedTime / 3600);
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  } else if (elapsedTime < 604800) {
    const days = Math.floor(elapsedTime / 86400);
    return days === 1 ? '1 day ago' : `${days} days ago`;
  } else if (elapsedTime < 2419200) {
    const weeks = Math.floor(elapsedTime / 604800);
    return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
  } else {
    const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };
    return dateTime.toLocaleDateString(undefined, options);
  }
};

export default getTimeStringDate